import React, { useState } from 'react';

import { apiSahBudgetPrintToSignRecords } from '~constants/api';

import { downloadFile } from '~libs/genericAction';
import { useToast } from '~libs/toast';

import { ClickableIcon, Spinner } from '~components';
import { faDownload } from '~components/icon';

interface ComponentProps {
  id: string;
  fileName: string;
}

const PrintToSignRecordActionButtons: React.FC<ComponentProps> = ({ id, fileName }) => {
  const [downloading, setDownloading] = useState(false);
  const { showToast } = useToast();

  const download = async () => {
    if (downloading) return;
    setDownloading(true);
    try {
      const url = await downloadFile(`${apiSahBudgetPrintToSignRecords}/${id}/download`, fileName);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(url);
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Download failed';
      showToast('danger', message);
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div className="d-flex justify-content-end align-items-center gap-2">
      {downloading ? (
        <Spinner
          type="clip"
          size={16}
          loading
          className="ms-2 me-2"
          dataCy={`${id}-print-to-sign-record-download-spinner`}
        />
      ) : (
        <ClickableIcon
          id={`${id}-print-to-sign-record-download`}
          icon={faDownload}
          toolTip="Download"
          color="success"
          onClick={download}
        />
      )}
    </div>
  );
};

export default PrintToSignRecordActionButtons;
